import React, { useState } from 'react'
import { IconShare } from '@tabler/icons-react'

import { Button } from '@/components/buttons/Button'
import { CopyButton } from '@/components/buttons/CopyButton'
import { TextInput } from '@/components/forms/TextInput'
import { BasicModal } from '@/components/layout/modals/BasicModal'

export const KodiShareButton = ({ sessionId }) => {
  const [open, setOpen] = useState(false)
  const [copied, setCopied] = useState(false)
  const shareUrl = `${window.location.origin}/kodi/${sessionId}`

  const closeModal = () => {
    setOpen(false)
    setCopied(false)
  }

  return (
    <>
      <Button
        small
        icon={<IconShare stroke={1.5} />}
        data-testid="kodi-share-button"
        onClick={() => setOpen(true)}
      >
        Share
      </Button>
      <BasicModal
        show={open}
        size="tiny"
        title="Share this session"
        onClose={closeModal}
        footer={
          <div className="flex-align-center flex-end small-gap">
            <Button onClick={closeModal}>Close</Button>
          </div>
        }
      >
        <div className="flex-column medium-gap">
          <p className="no-margin muted-text">
            Anyone in your organization who has this link can view this session, read-only. They
            can&apos;t send messages or change anything.
          </p>
          <TextInput
            readOnly
            aria-label="Session URL"
            value={shareUrl}
            data-testid="kodi-share-url"
            onFocus={(event) => event.target.select()}
            endAction={
              <CopyButton
                iconOnly
                basic
                content={shareUrl}
                aria-label="Copy URL"
                onCopy={() => setCopied(true)}
              />
            }
          />
          <div className="cowork-visually-hidden" role="status" aria-live="polite">
            {copied && 'URL copied'}
          </div>
        </div>
      </BasicModal>
    </>
  )
}
